'use strict';

var AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes'),
    Analytics = require('../utils/Analytics'),
    AnalyticsEvents = require('../constants/AnalyticsEvents'),
    NavigationStore = require('../stores/NavigationStore'),
    NavigationContextTypes = require('../constants/NavigationContextTypes'),
    ModalTypes = require('../constants/ModalTypes'),
    invariant = require('react/lib/invariant'),
    assign = require('react/lib/Object.assign');

function getAnalyticsEventId(modalId) {
  switch (modalId) {
  case ModalTypes.ABOUT:
    return AnalyticsEvents.FORMS_ABOUT_SHOW;
  case ModalTypes.SIGNUP:
    return AnalyticsEvents.FORMS_SIGNUP_SHOW;
  case ModalTypes.LOGIN:
    return AnalyticsEvents.FORMS_LOGIN_SHOW;
  case ModalTypes.FINISH_SIGNUP:
    return AnalyticsEvents.FORMS_FINISH_SIGNUP_SHOW;
  case ModalTypes.SEND_INVITE:
    return AnalyticsEvents.FORMS_SEND_INVITE_SHOW;
  case ModalTypes.FEEDBACK:
    return AnalyticsEvents.FORMS_FEEDBACK_SHOW;
  case ModalTypes.EDITOR_HELP:
    return AnalyticsEvents.EDITOR_HELP_SHOW;
  }
}

var ModalActionCreators = {
  showModal(id, options) {
    invariant(
      ModalTypes.hasOwnProperty(id),
      'showModal() accepts a constant from ModalTypes. You passed %s',
      id
    );

    var isInAbout = NavigationStore.isActive(NavigationContextTypes.ABOUT);
    if (isInAbout && id === ModalTypes.ABOUT) {
      id = ModalTypes.SIGNUP;
    }

    AppDispatcher.handleViewAction({
      type: ActionTypes.SHOW_MODAL,
      modal: assign({ id: id }, options)
    });

    var eventId = getAnalyticsEventId(id),
        source = options && options.source;

    if (eventId) {
      Analytics.trackGAEvent(eventId, source);
      Analytics.trackEvent(eventId, {
        source: source
      });
    }
  },

  hideModal(id) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.HIDE_MODAL,
      modal: { id: id }
    });
  }
};

module.exports = ModalActionCreators;



/** WEBPACK FOOTER **
 ** ./actions/ModalActionCreators.js
 **/